var _jsxFileName = "/src/main/react/src/main/app/components/Routes.js";
import React, { Component } from 'react';
import Login from "./login/Login";
import { Homepage, EntitySelected, Upload, SearchResult, AdminPortal, PasswordReset, ContactSupport, UpdateProgram, TitleSearch } from "./pages/";
import { Route, Switch } from "react-router-dom/es/";
import Error from './navigation/Error';
import { withStyles } from '@material-ui/core/styles';
const styles = () => {};

/** Constants for paths **/
export const LOGIN = '/login';
export const HOMEPAGE = '/';
export const ENTITY_SELECTED = '/entity';
export const UPDATE_PROGRAM = '/update-program';
export const UPLOAD = '/upload';
export const SEARCH = '/search';
export const SEARCH_RESULT = '/search-result';
export const ERROR = '/error';
export const ADMIN = '/admin';
export const RESETCODE = '/verify-user';
export const RESETPASS = '/reset-password';
export const SUPPORT = '/support';

/**
 * Handles the routing inside of the React application.
 */
class Routes extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return /*#__PURE__*/React.createElement("div", {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 46,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Switch, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 47,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Route, {
      path: LOGIN,
      exact: true,
      component: Login,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 48,
        columnNumber: 21
      }
    }), /*#__PURE__*/React.createElement(Route, {
      path: HOMEPAGE,
      exact: true,
      component: Homepage,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 49,
        columnNumber: 21
      }
    }), /*#__PURE__*/React.createElement(Route, {
      path: ENTITY_SELECTED,
      exact: true,
      component: EntitySelected,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 50,
        columnNumber: 21
      }
    }), /*#__PURE__*/React.createElement(Route, {
      path: UPDATE_PROGRAM,
      exact: true,
      component: UpdateProgram,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 51,
        columnNumber: 21
      }
    }), /*#__PURE__*/React.createElement(Route, {
      path: UPLOAD,
      exact: true,
      component: Upload,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 52,
        columnNumber: 21
      }
    }), /*#__PURE__*/React.createElement(Route, {
      path: SEARCH,
      exact: true,
      component: SearchResult,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 53,
        columnNumber: 21
      }
    }), /*#__PURE__*/React.createElement(Route, {
      path: SEARCH_RESULT,
      exact: true,
      component: TitleSearch,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 54,
        columnNumber: 21
      }
    }), /*#__PURE__*/React.createElement(Route, {
      path: ADMIN,
      exact: true,
      component: AdminPortal,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 55,
        columnNumber: 21
      }
    }), /*#__PURE__*/React.createElement(Route, {
      path: RESETCODE,
      exact: true,
      component: PasswordReset,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 56,
        columnNumber: 21
      }
    }), /*#__PURE__*/React.createElement(Route, {
      path: RESETPASS,
      exact: true,
      component: PasswordReset,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 57,
        columnNumber: 21
      }
    }), /*#__PURE__*/React.createElement(Route, {
      path: SUPPORT,
      exact: true,
      component: ContactSupport,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 58,
        columnNumber: 21
      }
    }), /*#__PURE__*/React.createElement(Route, {
      path: ERROR,
      exact: true,
      component: Error,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 60,
        columnNumber: 21
      }
    }), /*#__PURE__*/React.createElement(Route, {
      to: Error,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 61,
        columnNumber: 21
      }
    })));
  }
}
export default withStyles(styles)(Routes);